export const options = [
  {
    id: 'not-at-all',
    title: 'Not at all nervous',
  },
  {
    id: 'a-little',
    title: 'A little nervous',
  },
  {
    id: 'moderately',
    title: 'Moderately nervous',
  },
  {
    id: 'very',
    title: 'Very nervous',
  },
  {
    id: 'extremely',
    title: 'Extremely nervous',
  },
];
